import {
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import {
  ApiService,
  IListData,
} from 'src/app/shared/services/api/api/api.service';
import { ToasterService } from 'src/app/shared/services/toaster/toaster.service';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as fs from 'file-saver';
import { Column, Workbook } from 'exceljs';

@Component({
  selector: 'app-players-completed',
  templateUrl: './players-completed.component.html',
  styleUrls: ['./players-completed.component.scss'],
})
export class PlayersCompletedComponent implements OnInit, OnDestroy {
  @Input()
  name = 'Code of Conduct';

  players = [];

  submitType = 'Add';
  totalPlayers = 0;
  limit = 1000000;
  skip = 0;
  pageSize = 1000;
  search = '';
  page = 1;

  searchForm: UntypedFormGroup = this._formBuilder.group({
    searchCtrl: new UntypedFormControl(''),
  });

  companiesList = [];
  unsubscribe$ = new Subject<void>();
  constructor(
    // private _route: Router,
    private _formBuilder: UntypedFormBuilder,
    private _api: ApiService,
    private _cdr: ChangeDetectorRef,
    private _toast: ToasterService,
  ) {}

  ngOnInit(): void {
    console.log('name: ', this.name);

    if (this.name === 'IT Security') {
      this.getLearningGamePlayers('62396cbf25fd590013c06c06');
    } else if (this.name === 'Insider Trading') {
      this.getLearningGamePlayers('6151a53fcfe5f500140a2e49');
    } else if (this.name === 'Posh') {
      this.getLearningGamePlayers('62d7e38a1d618000122ea439');
    } else if (this.name === 'Health and Safety') {
      this.getLearningGamePlayers('62da67551d618000122ed1df');
    } else {
      this.getCocPlayers();
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  getCocPlayers(): void {
    const query: {
      limit: any;
      skip: any;
      divisions?: any;
      search?: any;
    } = { limit: this.limit, skip: this.skip };

    if (this.search) {
      query.search = this.search;
    }

    // if (this.divisionIds.length) {
    //   query.divisions = this.divisionIds;
    // }
    this._api
      .getCompletedPlayers(query, '5f9185f2c60b8e0011a0f1be')
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (data: IListData) => {
          this.players = data.list;
          this.players.forEach(
            (player) =>
              (player['name'] =
                (player['firstName'] || '') + ' ' + (player['lastName'] || '')),
          );
          // console.log(this.players);
          this.totalPlayers = data.totalCount;
          // this._cdr.detectChanges();
        },
        (err) => {
          this._toast.showError(err.error.message);
        },
      );
  }

  getLearningGamePlayers(divisionId: string): void {
    const query: {
      limit: any;
      skip: any;
      divisions?: any;
      search?: any;
    } = { limit: this.limit, skip: this.skip };

    if (this.search) {
      query.search = this.search;
    }

    // if (this.divisionIds.length) {
    //   query.divisions = this.divisionIds;
    // }
    this._api
      .getLearningPlayerLeaderboard(divisionId)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (data: any[]) => {
          this.players = data;
          this.players.forEach(
            (player) =>
              (player['name'] =
                (player['firstName'] || '') +
                ' ' +
                (player['lastName'] || '') +
                (player['lastname'] || '')),
          );
          console.log('players: ', this.players);

          // console.log(this.players);
          this.totalPlayers = data.length;

          // this._cdr.detectChanges();
        },
        (err) => {
          this._toast.showError(err.error.message);
        },
      );
  }

  loadPageData(data): void {
    this.skip = data.index;
    this.search = data.search ? data.search : '';

    if (this.name === 'IT Security') {
      this.getLearningGamePlayers('62396cbf25fd590013c06c06');
    } else if (this.name === 'Insider Trading') {
      this.getLearningGamePlayers('6151a53fcfe5f500140a2e49');
    } else {
      this.getCocPlayers();
    }
  }

  loadPage(e, search?): void {
    this.page = e;
    const index = e * this.pageSize - this.pageSize;
    this.loadPageData({ index, countToShow: this.pageSize, search });
  }

  onSearchChange(e): void {
    this.skip = 0;
    this.players = [];
    this.loadPage('1', e);
  }

  downloadReport(): void {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet(this.name);

    let worksheetColumns = [];

    if (
      this.name === 'Code of Conduct' ||
      this.name === 'Posh' ||
      this.name === 'Health and Safety'
    ) {
      worksheetColumns = [
        { header: 'Name', key: 'name', width: 50 } as Column,
        { header: 'Email', key: 'email', width: 50 } as Column,
        { header: 'Played On', key: 'createdAt', width: 50 } as Column,
        { header: 'Score', key: 'highestScore', width: 25 } as Column,
      ];
    } else if (this.name === 'Insider Trading') {
      worksheetColumns = [
        { header: 'Email', key: 'email', width: 50 } as Column,
        { header: 'Status', key: 'status', width: 50 } as Column,
        { header: 'Score', key: 'score', width: 25 } as Column,
      ];
    } else if (this.name === 'IT Security') {
      worksheetColumns = [
        { header: 'Name', key: 'name', width: 40 } as Column,
        { header: 'Email', key: 'email', width: 40 } as Column,
        { header: 'Status', key: 'status', width: 50 } as Column,
        { header: 'Score', key: 'score', width: 25 } as Column,
      ];
    }

    worksheet.columns = worksheetColumns;
    worksheet.addRows(this.players);
    workbook.xlsx.writeBuffer().then((data) => {
      const blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      fs.saveAs(blob, this.name + '.xlsx');
    });
  }
}
